<template>
  <div>
    <div v-if="loading">
      Loading data ...
    </div>
    <Requests :profileId="profileId"
              v-on:openmenuitem="openMenuItem"
    />
    <div v-if="!loading">
      <div class="content-block-title flex-between">{{ profile.kidName != '' ? profile.kidName : 'Kid' }}’s statistic
        <button class="btn-icon ml-1 desktop-hidden" @click="$emit('openmobilemenu')"><i class="icon-edit"></i></button></div>
      <div class="content-block-item">
        <div class="stat-limit flex-between">
        <div class="w-100 mr-2">
          <p>{{$lang.messages.statistic.daily_limit}}</p>
          <div class="progress w-100">
            <div class="progress-label">
              <span class="text-bold text-md">{{ Math.floor(profile.dailyLimitUsed/60) }}</span>
              <span class="text-thin">m</span>
            </div>
            <div class="progress-label" v-if="profile.todayDailyLimit < 86400">
              <span class="text-bold text-md">{{ Math.floor(profile.todayDailyLimit/60) }}</span>
              <span class="text-thin">m</span>
            </div>
            <div class="progress-percent" :style="{width: profile.dailyLimitUsed / profile.todayDailyLimit * 100 +'%'}"></div>
          </div>
        </div>
        <div class="stat-time">
          <p class="flex-between nowrap">
            <span class="text-muted text-thin mr-1">{{$lang.messages.statistic.last_week}}</span>
            <span>
              <span class="text-600" v-if="lastWeekUsed.hours != 0">{{ lastWeekUsed.hours }}</span>
              <span v-if="lastWeekUsed.hours != 0" class="text-thin">h</span>
              <span class="text-600"> {{ lastWeekUsed.minutes }}</span><span class="text-thin">m</span>
          </span>
          </p>
          <hr>
          <p class="flex-between nowrap"><span class="text-muted text-thin mr-1">{{$lang.messages.statistic.last_month}}</span>
            <span>
              <span class="text-600" v-if="lastMonthUsed.hours != 0">{{ lastMonthUsed.hours }}</span>
              <span class="text-thin" v-if="lastMonthUsed.hours != 0">h</span>
              <span class="text-600"> {{ lastMonthUsed.minutes }}</span>
              <span class="text-thin">m</span>
            </span>
          </p>
        </div>
      </div>
      </div>
      <div class="history-block">
        <div class="history-controls-block flex-between flex-v-center">
          <div class="history-controls">
            <div class="history-controls-item" :class="{active : chartMode === 'Today'}"  @click="fillDayData">{{$lang.messages.statistic.today}}</div>
            <div class="history-controls-item" :class="{active : chartMode === 'Week'}" @click="fillWeekData(true)">{{$lang.messages.statistic.week}}</div>
            <div class="history-controls-item" :class="{active : chartMode === 'Month'}" @click="fillMonthData">{{$lang.messages.statistic.month}}</div>
          </div>
          <div class="history-controls flex-v-center" v-if="devices">
            <span class="text-bold">{{$lang.messages.show}} &nbsp;</span>
            <v-select
                :disabled="!isPremium"
                :searchable="false"
                :label="devicesArray.name"
                :value="devicesArray.find(item => item.value === deviceSorting)"
                :clearable="false"
                :options="devicesArray" @input="sortStatisticBydevice">
              <template slot="open-indicator">
                <svg class="vs__open-indicator" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 0.5L5.5 5L10 0.5" stroke="#7D6AED"/>
                </svg>
              </template>
            </v-select>
          </div>
          <div class="datepicker">
            <DateRangePicker
                v-model="dateRange"
                @update="fillRangeData(true, true)"
                :max-date="maxDate"
                single-date-picker="range"
                opens="left"
            />
          </div>
        </div>
        <div style="overflow: auto">
          <HistoryChart :chartData="datacollection" :style="chartStyles"/>
        </div>
        <div class="flex flex-v-top mt-2 history-sites-wrap">
          <div class="history-sites mb-xs-1">
            <div class="content-block-subtitle">
              {{chartMode === 'Today' || chartMode === 'Month' || chartMode === 'Week' ? chartMode : 'Period'}}
              {{$lang.messages.statistic.activity_history}}
              <span v-tooltip="$lang.messages.statistic.activity_history_tooltip" class="info-icon"></span>
            </div>
            <div v-if="activityHistoryData && activityHistoryData.length">
              <HistoryProgress :key="item.index" v-for="item in activityHistoryData.slice(0,4)" v-bind="item" :maxSiteTime = "maxTimeValue"/>
              <div v-if="activityHistoryData.length > 1 && showAllSites">
                <HistoryProgress :key="item.index" v-for="item in activityHistoryData.slice(4,activityHistoryData.length)" v-bind="item" :maxSiteTime = "maxTimeValue"/>
              </div>
              <div v-if="activityHistoryData.length > 4" class="mt-2">
                <span class="link-collapse" @click="showAllSites = !showAllSites">
                  {{$lang.messages.show}} {{showAllSites ? 'less' : 'all'}} {{$lang.messages.activity}}
                  <span class="text-thin">({{ showAllSites ? '4' : activityHistoryData.length }})</span>
                </span>
              </div>
            </div>
            <div v-else>
              <div class="history-empty">
                <div class="history-empty-content text-center">
                  <i class="icon-statistic"></i><br>
                  {{$lang.messages.no_data_yet}}
                </div>
                <div class="history-progress -disabled" v-for="index in 4" :key="index">
                  <div class="flex flex-v-top">
                    <div class="history-progress-icon"></div>
                    <div class="flex w-100 flex-v-center flex-between">
                      <span class="history-progress-title"></span>
                      <span class="history-progress-value">0m</span>
                    </div>
                  </div>
                  <div class="history-progress-line"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isPremium" class="premium-banner -dashboard ml-1" @click="clickBanner">
            <picture>
              <source srcset="../assets/img/premium-dashboard-sm.svg" media="(max-width: 600px)">
              <source srcset="../assets/img/premium-dashboard.svg" media="(min-width: 601px)">
              <img src="../assets/img/premium-dashboard.svg" alt="MDN">
            </picture>
            <button class="btn btn-premium">{{$lang.messages.get_premium}}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HistoryChart from "@/components/HistoryChart"
import HistoryProgress from "@/components/HistoryProgress"
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import {recommendedLinks} from "../helpers/configs"
import saveSetting from "@/components/mixins/saveSetting";
import {mapState} from "vuex";
import Requests from "@/components/Requests";

export default {
  name: 'Statistics',
  mixins: [saveSetting],
  components: {
    Requests,
    HistoryProgress,
    HistoryChart,
    DateRangePicker
  },
  props: ['profileId', 'profile'],
  data: function () {
    let startDate = new Date();
    let endDate = new Date();
    endDate.setDate(endDate.getDate() + 6)
    return {
      loading: false,
      maxDate: new Date(startDate.getFullYear(), startDate.getMonth() + 2, 0),
      dateRange: {startDate, endDate},
      showAllSites: false,
      datacollection: null,
      rangeDataValue: [],
      chartType: 'line',
      chartMode: 'Week',
      historySitesRange: null,
      activityHistoryData: [],
      maxTimeValue: 0,
      deviceSorting: 'daysList'
    }
  },
  computed: {
    chartStyles() {
      return {
        position: 'relative',
        height: '400px',
        width: this.chartMode === 'Month' && window.innerWidth < 600 ? '600px' : '100%'
      }
    },
    lastWeekUsed(){
      const today = new Date(Date.now())
      const weekEndDate = today.getTime()
      const weekStartDate = today.setUTCDate(today.getUTCDate() - 6)
      return this.countUsedTime(weekStartDate,weekEndDate)
    },
    lastMonthUsed () {
      const today = new Date(Date.now())
      const monthEndDate = today.getTime()
      const monthStartDate = today.setUTCDate(today.getUTCDate() - 30)
      return this.countUsedTime(monthStartDate,monthEndDate)
    },
    ...mapState({
      user: state => state.user.uid,
      devices: state => state.accountData.devices,
      currentDeviceID: state => state.currentDeviceID,
      isPremium: state => state.accountData.isPremium
    }),
    devicesArray(){
      let devicesArr = [{
        value: 'daysList',
        label: 'All devices'
      }]
      Object.keys(this.devices).map((key) => devicesArr.push({
        value: key,
        label: this.devices[key].name
      }));
      return devicesArr
    }
  },
  watch: {
    profile: function (){
      this.fillWeekData()
      this.setActivityHistory()
    },
    siteSectionOpen: function (newVal) {
      if (!newVal) {
        this.chartMode = 'week';
        this.fillWeekData();
      }
    }
  },
  mounted: function (){
    this.loading = true
    this.fillWeekData()
    this.setActivityHistory()
  },
  methods: {
    openMenuItem (title, addInfo) {
      this.$emit('openmenuitem', title, addInfo);
    },
    clickBanner () {
      this.$emit('openonlypremiummodal')
    },
    countUsedTime(dateRangeStart, dateRangeEnd){
      if(this.profile.statistic){
        let usedTime = 0
        let daysArray = []
        this.getDateRange(dateRangeStart, dateRangeEnd).forEach((item) => daysArray.push(this.getDateFromStamp(item)))
        daysArray.forEach((item) => {
          let obj = this.profile.statistic.daysList[item]
          if(obj){
            Object.values(obj).forEach((item) => {
              usedTime = usedTime + item
            })
          }
        })

        let hours = Math.floor(usedTime / 3600)
        let minutes = Math.round((usedTime - (hours * 3600)) / 60)
        return {
          hours: hours,
          minutes: minutes
        }
      } else {
        return {
          hours: '0',
          minutes: '0'
        }
      }
    },
    setActivityHistory() {
      if (this.profile.statistic){
        const daysArray = []
        let domainVisited = [];
        const tempObj = {};
        this.getDateRange(this.dateRange.startDate, this.dateRange.endDate).forEach((item) => daysArray.push(this.getDateFromStamp(item)))
        daysArray.forEach((item) => {
          let obj = this.profile.statistic[this.deviceSorting] ? this.profile.statistic[this.deviceSorting][item] : undefined
          if (obj) {
            Object.keys(obj).forEach((domain) => {
              if (tempObj[domain]) {
                tempObj[domain] = tempObj[domain] + obj[domain]
              } else {
                tempObj[domain] = obj[domain];
              }
            })
          }
        })

        Object.keys(tempObj).forEach(item => {
          domainVisited.push({
            domain: item,
            time: tempObj[item],
          })
        })

        domainVisited.sort((firstEl, secondEL) => {
          return secondEL.time - firstEl.time;
        })

        this.maxTimeValue = domainVisited.length ? domainVisited[0].time : 0
        domainVisited.forEach((item) => {
          const findDomain = recommendedLinks.find(link => link.domain === item.domain.replace(/|/g, '.'))
          if(findDomain){
            item.staticIcon = findDomain.icon
          }
        })
        this.activityHistoryData = domainVisited;
        this.loading = false
      } else {
        this.activityHistoryData = null
        this.loading = false
      }
    },
    setHistorySitesRange() {
      if (this.profile.statistic){
        let rangeArray = []
        this.rangeDataValue.forEach((item) => {
          let daySum = 0
          let obj = this.profile.statistic[this.deviceSorting] ? this.profile.statistic[this.deviceSorting][item] : undefined
          if (obj){
            let result = Object.values(obj)
            result.forEach((item) => {
              daySum += item/60
            })
          }
          rangeArray.push(Math.round(daySum * 100) / 100)
          this.historySitesRange = rangeArray
        })
      } else {
        this.historySitesRange = null
      }
    },
    getDateFromStamp(stamp){
      const date = new Date(stamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      return year + '|' + month + '|' + day
    },
    getDateRange(startDate, endDate, steps = 1) {
      const dateArray = [];
      let currentDate = new Date(startDate);

      while (currentDate <= new Date(endDate)) {
        dateArray.push(new Date(currentDate).getTime());
        currentDate.setUTCDate(currentDate.getUTCDate() + steps);
      }
      return dateArray;
    },
    fillRangeData(click = false, fromDP) {
      console.log(click);
    /*  if (!this.isPremium && click) {
        this.$emit('openonlypremiummodal')
        return false
      }*/

      if (fromDP) {
        this.chartMode = 'Period'
      }

      let chartLabelsArray = []
      if (this.dateRange.endDate === this.dateRange.startDate) {
        chartLabelsArray = [this.getDateFromStamp(this.dateRange.startDate.getTime()).replace(/\|/, '/')]
        this.rangeDataValue = [this.getDateFromStamp(this.dateRange.startDate.getTime())]
      } else {
        this.rangeDataValue = []
        this.getDateRange(this.dateRange.startDate, this.dateRange.endDate)
            .forEach((item) => {
              chartLabelsArray.push(this.getDateFromStamp(item)
                .replace(/\|/g, '/'))})
        this.getDateRange(this.dateRange.startDate, this.dateRange.endDate).forEach((item) => this.rangeDataValue.push(this.getDateFromStamp(item)))
      }
      this.setActivityHistory()
      this.setHistorySitesRange()
      this.datacollection = {
        labels: chartLabelsArray,
        datasets: [
          {
            label: "",
            data: this.historySitesRange,
            backgroundColor: "rgba(116, 89, 217, 0.1",
            borderColor: "rgba(66, 47, 138, 0.87)",
            pointBackgroundColor: "rgba(66, 47, 138, 0.87)"
          }
        ]
      }
    },
    fillDayData() {
    /*  if (!this.isPremium) {
        this.$emit('openonlypremiummodal')
        return false
      }*/
      const today = new Date(Date.now())
      this.dateRange.endDate = today
      this.dateRange.startDate = today
      this.fillRangeData()
      this.chartMode = 'Today'
    },
    fillWeekData(click = false) {
      const today = new Date(Date.now())
      this.dateRange.endDate = today.getTime()
      this.dateRange.startDate = today.setUTCDate(today.getUTCDate() - 6)
      this.fillRangeData(click)
      this.chartMode = 'Week'
    },
    fillMonthData() {
     /* if (!this.isPremium){
        this.$emit('openonlypremiummodal')
        return false
      }*/
      const today = new Date(Date.now())
      this.dateRange.endDate = today.getTime()
      this.dateRange.startDate = today.setUTCDate(today.getUTCDate() - 30)
      this.fillRangeData()
      this.chartMode = 'Month'
    },
    sortStatisticBydevice(selectValue) {
      this.deviceSorting = selectValue.value;
      this.fillRangeData();
      // this.setHistorySitesRange();
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/helpers";

.chartjs-render-monitor {
  max-height: 100%;
  max-width: 100%;
}

.progress {
  background: #EFF0F7;
  border-radius: 8px;
  height: 33px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  width: 100%;
  margin-right: 40px;
  overflow: hidden;

  &.blocked:after {
    content: "";
    width: 100%;
    height: 100%;
    display: block;
    background: #EFF0F7;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    opacity: 0.8;
    border-radius: 8px;
  }

  &-label {
    position: relative;
    z-index: 1;
  }

  &-percent {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 8px;
    max-width: 100%;
    background-image: repeating-linear-gradient(-45deg, #FFB648, #FFB648 5px, #ffdaa1 5px, #ffdaa1 10px);
  }
}

.usage-time {
  font-size: 48px;
  font-weight: 600;

  &-value {
    font-size: 20px;
  }
}

.history-controls {
  display: flex;
  margin-top: 30px;
  margin-bottom: 30px;

  @include responsive-below($lg) {
    margin-top: 16px;
    margin-bottom: 16px;
  }

  &-item {
    border-radius: 60px;
    font-weight: 700;
    color: #000;
    font-size: 18px;
    line-height: 28px;
    padding: 0 30px;
    display: inline-block;
    cursor: pointer;
    transition: all 0.3s;

    &.active {
      background: #EFF0F7;
    }
  }

  &-block {
    @include responsive-below($lg) {
      flex-direction: column;
      margin-bottom: 16px;
    }
  }
}

.history-sites {
  width: 100%;
  border-radius: 20px;

  &.gray {
    background: #F5F7FB;
    padding: 24px;
  }
}

.history-sites-wrap {
  @include responsive-below($xs){
    flex-wrap: wrap;

    .premium-banner {
      margin: 0 auto !important;
    }
  }
}

.link-collapse {
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  color: #2D79EC;
}

.reportrange-text.form-control {
  background: #EFF0F7;
  border-radius: 60px;
  border: 0;
  font-weight: 600;
  color: #7D6AED;
  padding: 5px 15px;

  &:before {
    content: "\e905";
    color: #7d6aed;
    font-family: 'icomoon' !important;
    margin-right: 5px;
    vertical-align: middle;
  }
}

.site-request {
  padding: 20px 24px;
  color: #fff;
  background: linear-gradient(90deg, #9485EF 0%, #9E8DE2 100%);
  border-radius: 15px;

  @include responsive-below($xs){
    padding: 16px;
  }

  .btn + .btn {
    margin-left: 16px;

    @include responsive-below($xl){
      margin-top: 10px;
    }

    @include responsive-below($xs){
      margin-top: 0;
    }
  }

  .btn-icon .icon-close:before {
    color: #fff;
  }
}

.daterangepicker {
  .ranges {
    display: none;
  }
  td.in-range {
    background-color: #EFF0F7;
  }
  td.active, td.active:hover {
    background-color: #7D6AED;
  }
  .btn-primary, .btn-success {
    background-color: #FDD04C;

    &:hover {
      background-color: #FFDE7E;
    }
  }
  .btn-secondary {
    background-color: #BEC1DA;

    &:hover {
      background-color: #696E93;
    }
  }
}

@include responsive-above('339px'){
  .daterangepicker.single.show-ranges.show-weeknumbers, .daterangepicker.single.show-ranges {
    min-width: 260px !important;
  }
}


@include responsive-below($md){
  .stat {
    &-limit {
      flex-direction: column;
    }

    &-time {
      display: flex;
      margin-top: 16px;
    }
  }
}

</style>

